import {
  CreateProcessFromTemplateDocument,
  CreateProcessFromTemplateMutation,
  CreateProcessFromTemplateMutationVariables,
  GetProcessesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type Process = NonNullable<
  CreateProcessFromTemplateMutation['processesMutations']['createProcessesProcess']
>['process']

export const useCreateProcessFromTemplate = () => {
  const [executeMutation, { loading }] = useMutation(CreateProcessFromTemplateDocument, {
    extractorFn: (data: CreateProcessFromTemplateMutation) =>
      data.processesMutations.createProcessesProcess,
  })

  return {
    loading,
    createProcess(variables: CreateProcessFromTemplateMutationVariables) {
      return executeMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetProcessesDocument,
          },
        ],
      })
    },
  }
}
